import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "helperTip" }

import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelperTip',
  props: {
    title: {},
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      "icon-name": "info",
      "aria-hidden": "true"
    }),
    _createElementVNode("div", null, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}
}

})